
import { useState } from "react";

// Variable para controlar si ya se mostró el modal
let modalShownInSession = false;

export const useModalState = () => {
  const [showModal, setShowModal] = useState(false);
  const [isProfileBeingCompleted, setIsProfileBeingCompleted] = useState(false);

  const showProfileModal = () => {
    console.log("Profile is incomplete, showing forced modal");
    // Al detectar perfil incompleto, limpiar el sessionStorage para forzar la actualización
    sessionStorage.removeItem("profileCompleted");
    setShowModal(true);
    setIsProfileBeingCompleted(true);
    // Marcamos que ya mostramos el modal en esta sesión
    modalShownInSession = true;
  };

  const hideProfileModal = () => {
    console.log("Profile is now complete, hiding modal");
    sessionStorage.setItem("profileCompleted", "true");
    setShowModal(false);
    setIsProfileBeingCompleted(false);
    // Reiniciamos la bandera para permitir mostrar el modal en futuras sesiones si es necesario
    modalShownInSession = false;
  };

  const resetModalSession = () => {
    modalShownInSession = false;
  };

  return {
    showModal,
    setShowModal,
    isProfileBeingCompleted,
    setIsProfileBeingCompleted,
    modalShownInSession,
    showProfileModal,
    hideProfileModal,
    resetModalSession
  };
};
